import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material";
import { useLeftBar } from "../../context/LeftBar";
import MobileMenu from "../LeftSideMenu/MobileMenu";
import LeftSideMenu from "../LeftSideMenu/LeftSideMenu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ReactComponent as IconInsights } from "../../assets/icons/sideMenu/iconInsights.svg";

const LayoutWrapperDiv = styled("div")(({ theme, open }) => ({
  alignItems: "start",
  borderRadius: "16px",
  flexDirection: "row",
  height: "100%",
  justifyContent: "space-between",
  padding: "6px 24px 24px",
  marginLeft: open ? "215px" : "65px",
  width: `calc(100% - ${open ? "215px" : "65px"})`,
  boxSizing: "border-box",
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  [theme.breakpoints.down("sm")]: {
    marginLeft: 0,
    width: "100%",
    padding: "6px 16px 16px",
  },
}));

const menuItems = [
  {
    id: "home",
    muiIcon: <DashboardIcon />,
    name: "Resultados",
    path: "/overview",
  },
  {
    id: "positivity",
    muiIcon: <CurrencyExchangeIcon />,
    name: "Cobertura Base",
    path: "/positivity-total",
  },
  {
    id: "details",
    muiIcon: <QueryStatsIcon />,
    name: "Canais Digitais",
    path: "/details",
  },
  {
    id: "insights",
    muiIcon: <IconInsights />,
    name: "PC + Skin",
    path: "/insights",
  },
  {
    id: "roles",
    muiIcon: <DescriptionOutlinedIcon />,
    name: "Pontos top 10",
    path: "/roles",
  },
  {
    id: "roles",
    muiIcon: <DescriptionOutlinedIcon />,
    name: "Regras da Campanha",
    path: "/roles",
  },
  {
    id: "faq",
    muiIcon: <ContactSupportOutlinedIcon />,
    name: "Perguntas Frequentes",
    path: "/faq",
  },
];

function LayoutWrapper({ children }) {
  const { leftBarOpened } = useLeftBar();

  return (
    <div>
      <LeftSideMenu />
      <MobileMenu menuItems={menuItems} />
      <LayoutWrapperDiv open={leftBarOpened}>{children}</LayoutWrapperDiv>
    </div>
  );
}

LayoutWrapper.defaultProps = {
  children: null,
};

LayoutWrapper.propTypes = {
  children: PropTypes.object,
};

export default LayoutWrapper;
